import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// Parses `@[userId:Name]` tokens embedded in internal-note text into clickable pills.
// Mirrors request-v2's MentionPipe, but always expects a name alongside the id — see
// PermitInternalNoteComponent for why (request's own serializer drops the name on new
// mentions, which then fails to re-render; this pipe's counterpart always writes both).
@Pipe({ name: 'permitRenderMentions' })
export class PermitMentionPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(text: string, lang: string): SafeHtml {
        if (!text) return '';

        const escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

        const rendered = escaped.replace(/@\[([^\]:]+):([^\]]+)\]/g, (_match, id, name) => {
            if (name === '__deleted__') {
                const label = lang === 'fr' ? 'Utilisateur supprimé' : 'Deleted user';
                return `<span class="mention mention--deleted">@${label}</span>`;
            }
            return `<span class="mention" data-user-id="${id}" role="button" tabindex="0">@${name}</span>`;
        });

        return this.sanitizer.bypassSecurityTrustHtml(rendered);
    }
}
